import { jsx as o, jsxs as D, Fragment as g } from "react/jsx-runtime";
import { createContext as T, forwardRef as a, useContext as v, useState as C, useCallback as k, useMemo as R } from "react";
import { useMediaQuery as $ } from "@givebutter/react-util";
import * as F from "@radix-ui/react-dialog";
import { Title as M, Portal as j, Overlay as B, Close as H, Root as I, Cancel as S, Trigger as O } from "../dialog/Dialog.js";
import { Loader as P } from "../loader/Loader.js";
import { twMerge as l } from "tailwind-merge";
const b = T({}), z = ({
  defaultOpen: r,
  open: t,
  onOpenChange: e,
  children: s,
  ...n
}) => {
  const [i, c] = C(!!t || r), x = typeof t < "u" ? t : i, y = k(
    (u) => {
      e == null || e(u), c(u);
    },
    [e]
  ), d = R(() => ({ open: x, setOpen: y }), [x, y]);
  return /* @__PURE__ */ o(I, { modal: !1, open: d.open, onOpenChange: d.setOpen, ...n, children: /* @__PURE__ */ o(b.Provider, { value: d, children: s }) });
}, f = a(
  ({ className: r, ...t }, e) => /* @__PURE__ */ o(
    "div",
    {
      ref: e,
      className: l(
        "flex w-full flex-shrink items-center justify-between border-b border-b-gray-200 bg-white px-8 py-4",
        r
      ),
      ...t
    }
  )
);
f.displayName = "DrawerHeader";
const m = a(
  ({ className: r, ...t }, e) => /* @__PURE__ */ o(
    M,
    {
      ref: e,
      className: l("text-xl font-medium", r),
      ...t
    }
  )
);
m.displayName = "DrawerTitle";
const w = a(
  ({ className: r, ...t }, e) => /* @__PURE__ */ o(
    "div",
    {
      ref: e,
      className: l("flex-grow overflow-y-auto bg-white px-8 py-6", r),
      ...t
    }
  )
);
w.displayName = "DrawerBody";
const h = a(
  ({ overlayClassName: r, children: t, className: e, ...s }, n) => {
    const { open: i } = v(b), c = $("(max-width: 640px)");
    return /* @__PURE__ */ D(j, { children: [
      /* @__PURE__ */ o(B, { className: r }),
      /* @__PURE__ */ o(
        F.Content,
        {
          ref: n,
          className: l(
            "z-pentOutermost fixed bottom-0 right-0 top-0 flex h-full max-h-full flex-col border-l-gray-200 bg-white",
            "radix-state-open:animate-drawerIn radix-state-closed:animate-drawerOut",
            c ? "w-full" : "w-[36rem]",
            e
          ),
          ...s,
          children: i ? t : null
        }
      )
    ] });
  }
);
h.displayName = "DrawerContent";
const p = a(
  ({ className: r, ...t }, e) => /* @__PURE__ */ o(
    "div",
    {
      ref: e,
      className: l(
        "flex w-full flex-shrink border-t border-t-gray-200 bg-gray-50 px-8 py-4",
        r
      ),
      ...t
    }
  )
);
p.displayName = "DrawerFooter";
const L = ({ children: r }) => /* @__PURE__ */ D(g, { children: [
  /* @__PURE__ */ o(f, { children: /* @__PURE__ */ o(m, { children: r ?? /* @__PURE__ */ o(g, { children: " " }) }) }),
  /* @__PURE__ */ o(w, { children: /* @__PURE__ */ o(P, {}) }),
  /* @__PURE__ */ o(p, { children: " " })
] }), N = a(
  ({ className: r, ...t }, e) => /* @__PURE__ */ o(H, { ref: e, className: l("static", r), ...t })
);
N.displayName = "DrawerClose";
const Q = S, q = O, V = z, W = q, X = h, Y = f, Z = m, _ = N, ee = w, re = p, te = Q, oe = L;
export {
  ee as Body,
  te as Cancel,
  _ as Close,
  X as Content,
  w as DrawerBody,
  Q as DrawerCancel,
  N as DrawerClose,
  h as DrawerContent,
  b as DrawerContext,
  p as DrawerFooter,
  f as DrawerHeader,
  z as DrawerRoot,
  L as DrawerSkeleton,
  m as DrawerTitle,
  q as DrawerTrigger,
  re as Footer,
  Y as Header,
  V as Root,
  oe as Skeleton,
  Z as Title,
  W as Trigger
};
